import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useLocation } from '@reach/router';

import useCookie from '../../hooks/useCookie';
import selectors from '../../store/selectors';
import { ThemeContext } from '../Theme';

import AddParishLink from './AddParishLink';

const COOKIE_COOKIES_ACCEPTED_NAME = 'cookies_accepted';

const enhance = connect(state => ({
  parishData: selectors.getAccountData(state),
}));

const Footer = ({ parishData, isAbsolute, isWhite, mtAuto }) => {
  const [cookie, setCookie] = useCookie(COOKIE_COOKIES_ACCEPTED_NAME);
  const location = useLocation();

  const acceptCookies = () => {
    setCookie('yes', {
      maxAge: 365 * 3600 * 24,
    });
  };

  const { hideHeader } = useContext(ThemeContext);

  // Check if we're on the death prayers domain
  const isDeathPrayersPage = location?.hostname === 'wypominkionline.pl';

  const renderFooterLink = () => {
    if (hideHeader) {
      return <AddParishLink />;
    }

    if (isDeathPrayersPage) {
      return (
        <div className="d-block">
          <a href="https://wypominki.parafio.pl" target="_blank" rel="noreferrer">
            Wypominki Online
          </a>
          {' | '}
          <a href="https://parafio.com" target="_blank" rel="noreferrer">
            Parafio.com
          </a>
        </div>
      );
    }

    return (
      <a className="d-block" href="https://parafio.com" target="_blank" rel="noreferrer">
        Parafio.com
      </a>
    );
  };

  const renderMobileFooterLink = () => {
    if (hideHeader) {
      return <AddParishLink />;
    }

    if (isDeathPrayersPage) {
      return (
        <div className="d-block">
          <a href="https://wypominki.parafio.pl" target="_blank" rel="noreferrer">
            Wypominki Online
          </a>
          {' | '}
          <a href="https://parafio.com" target="_blank" rel="noreferrer">
            Parafio.com
          </a>
        </div>
      );
    }

    return (
      <a className="d-block" href="https://parafio.com" target="_blank" rel="noreferrer">
        Parafio.com
      </a>
    );
  };

  return (
    <footer
      className={classNames(
        'page-footer font-small',
        isAbsolute && 'be-absolute-lg',
        isWhite && 'white-footer',
        mtAuto && 'mt-auto',
      )}
    >
      <div className="footer-copyright p-3 d-lg-block text-center text-lg-left">
        {cookie ? (
          <div className="cookies-accepted">
            <div className="d-flex flex-column d-lg-block">
              <a href={parishData.getCookies}>Polityka cookies</a>{' '}
              <a href={parishData.getPrivacyPolicy}>Polityka prywatności</a>
              {hideHeader ? (
                <React.Fragment>
                  {' '}
                  <AddParishLink />
                </React.Fragment>
              ) : (
                renderFooterLink()
              )}
            </div>
          </div>
        ) : (
          <div className="cookies-not-accepted">
            <div>
              Używamy plików cookies. Przeczytaj{' '}
              <a href={parishData.getCookies}>Politykę Cookies</a>, aby dowiedzieć się więcej.{' '}
              <button onClick={acceptCookies} className="btn-hide-cookie" type="button">
                Rozumiem.
              </button>
            </div>
            <div>
              <a href={parishData.getPrivacyPolicy}>Polityka prywatności</a>
            </div>
            <div>{hideHeader ? <AddParishLink /> : renderMobileFooterLink()}</div>
          </div>
        )}
      </div>
    </footer>
  );
};

Footer.propTypes = {
  parishData: PropTypes.shape({
    getCookies: PropTypes.string,
    getPrivacyPolicy: PropTypes.string,
  }),
  isAbsolute: PropTypes.bool,
  isWhite: PropTypes.bool,
  mtAuto: PropTypes.bool,
};

export default enhance(Footer);
